import { appConfig } from "./app.config";

export const environment = {
    ...appConfig,
    name: "dev",
    webUrlBasePath: "https://dev.funfigz.com",
    apiUrlBasePath: "https://dev-api.funfigz.com/api",
};
